import { Stack, Typography } from '@mui/material'
import { OutOfOfficeIndicator } from '@omnea-app/fe-users-and-groups/OutOfOfficeIndicator'

export const USER_INFO_CLASS = 'user-info'

type UserInfoProps = {
  name: string
  isOutOfOffice?: boolean
  email?: string
}

export const UserInfo = ({ name, isOutOfOffice, email }: UserInfoProps) => {
  return (
    <Stack gap={1} className={USER_INFO_CLASS}>
      <Stack direction="row" alignItems="center" gap={2}>
        <Typography variant="body-medium">{name}</Typography>
        {isOutOfOffice && <OutOfOfficeIndicator />}
      </Stack>
      <Typography variant="small-regular">{email}</Typography>
    </Stack>
  )
}
